
	import { defineComponent } from 'vue';

	import FiscalYearReportByProgram from '@/ChildrenComponents/Reports/FiscalYearReportByProgram.vue';

	import { IProgramGraduationReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'program-served-report',
		components: { FiscalYearReportByProgram },
		data () {
			return {
				reportData: [] as IProgramGraduationReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getProgramGraduationReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
